import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  split,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { API_URL, TOKEN, WS_API_URL } from "../constant";

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        currencyBalace: {
          keyArgs: ['currencyId'],
        },
        euCoinsBalance: {
          keyArgs: false,
        },
      },
    },
    Balance: {
      keyFields: ['currency'],
    },
  },
});

const wsLink = new WebSocketLink({
  uri: WS_API_URL || `ws://localhost:4000/`,
  options: {
    reconnect: true,
  },
});

const link = createHttpLink({
  uri: `${API_URL}`,
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  link
);

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(TOKEN);
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const client = new ApolloClient({
  cache: cache,
  link: authLink.concat(splitLink),
  name: "react-web-client",
  version: "1.3",
  queryDeduplication: false,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-and-network",
    },
  },
});
